export interface CoreValue {
  title: string;
  description: string;
  icon: string;
}

export const coreValues: CoreValue[] = [
  {
    title: 'Safety',
    description:
      'We prioritize the safety of our workers, clients, and the public on every project. Our commitment to OSHA standards ensures a secure working environment.',
    icon: 'ShieldCheck',
  },
  {
    title: 'Integrity',
    description:
      'Honesty and transparency guide our business practices. We deliver on our promises and maintain ethical standards in all our dealings.',
    icon: 'Award',
  },
  {
    title: 'Quality',
    description:
      'Excellence in craftsmanship is non-negotiable. We use quality materials and skilled workmanship to ensure lasting results.',
    icon: 'Star',
  },
  {
    title: 'Sustainability',
    description:
      'We embrace environmentally conscious building practices that minimize waste and promote long-term environmental responsibility.',
    icon: 'Leaf',
  },
  {
    title: 'Innovation',
    description:
      'We continuously adopt modern techniques, technologies, and solutions to improve efficiency and deliver better outcomes for our clients.',
    icon: 'Lightbulb',
  },
];
